import styled from 'styled-components/native';

import ButtonWhitelabel from 'components/ButtonWhitelabel';

export default styled(ButtonWhitelabel)`
  align-self: auto;
  color: ${({ theme }) => theme.searchBar.iconColor};
  margin-left: 15px;
`;
